module.exports = __webpack_public_path__ + "img/12order.f3f7b8c4.png";